let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("l28up")).then(() => parcelRequire('ecDM5'));